/**
 * Casamento no tempo entre os quadros do loop e os dos raios, e o frescor do
 * índice — funções puras.
 *
 * O quadro dos raios das 14:10 junta os flashes de 14:10:00 a 14:19:59, com o
 * mesmo carimbo da imagem do STAR das 14:10. O casamento é exato; a tolerância
 * de 5 min só cobre um loop fora da grade de 10 min.
 */
import { MINUTE_MS } from '../lib/time';
import { varreduraParaQuadro } from '../radar/tempo';
import type { QuadroRaios } from './api';

export const TOLERANCIA_MS = 5 * MINUTE_MS;

export function quadroParaInstante(quadros: readonly QuadroRaios[], tempos: readonly number[], t: number | null): QuadroRaios | null {
  if (t === null || !quadros.length) return null;
  const i = varreduraParaQuadro(tempos, t, TOLERANCIA_MS);
  return i >= 0 ? quadros[i] : null;
}

/** A NOAA publica ~25 s depois da medição e a máquina lê a cada 20 s: o normal é o mais novo ter 0–15 min. */
export const ATRASO_AVISO_MIN = 30;
export const ATRASO_GRAVE_MIN = 6 * 60;

function quanto(min: number): string {
  return min >= 120 ? `${Math.floor(min / 60)} h` : `${Math.round(min)} min`;
}

export function avisoDeFrescor(ultimo: number | null, agora: number = Date.now()): string | null {
  if (ultimo === null) return null;
  const min = Math.max(0, (agora - ultimo) / MINUTE_MS);
  if (min >= ATRASO_GRAVE_MIN) return `Os raios estão sem quadro novo há ${quanto(min)}. O que está no mapa não são os raios de agora.`;
  if (min >= ATRASO_AVISO_MIN) return `Raios sem quadro novo há ${quanto(min)} — o normal é menos de 15 min.`;
  return null;
}
